import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
  Dropdown,
  Image,
  Input,
  Modal,
  Transition,
} from 'semantic-ui-react';
import Strings from '../../common/Strings';
import { getCurrencyText } from '../../helpers/currency';
import Constant from '../../common/Constant';
import { userActions } from '../../actions';
import '../Common.css';
import './AccountInformation.css';
import { getPlanInfo } from '../../helpers/subscription';
import { history } from '../../helpers';

class AccountInformation extends React.Component {
  static generatePreviewImgUrl(file, callback) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => callback(reader.result);
  }

  constructor(props) {
    super(props);

    this.state = {
      companyName: props.companyName,
      file: null,
      previewImgURL: props.companyImageURL,
      defaultCurrency: props.defaultCurrency,
      deleteModalOpen: false,
    };
  }

  onFileChange = event => {
    const file = event.target.files[0];

    // User cancelled
    if (!file) {
      return;
    }

    AccountInformation.generatePreviewImgUrl(file, previewImgURL => {
      this.setState({ file, previewImgURL }, this.checkFormChanged);
    });
  };

  onPressDeleteAccount = () => {
    this.setState({ deleteModalOpen: true });
  };

  handleCompanyNameChange = (e, { value }) => {
    this.setState(
      { companyName: value || this.props.companyName },
      this.checkFormChanged,
    );
  };

  changeCurrency = (e, { value }) => {
    this.setState({ defaultCurrency: value }, this.checkFormChanged);
  };

  doDeleteAccount = () => {
    const { dispatch } = this.props;
    dispatch(userActions.deleteAccount(this.state.password));
  };

  checkFormChanged = () => {
    const { previewImgURL, defaultCurrency } = this.state;
    const { companyName, companyImageURL } = this.props;
    const fieldsChanged =
      this.state.companyName !== companyName ||
      previewImgURL !== companyImageURL ||
      defaultCurrency !== this.props.defaultCurrency;
    this.props.formChanged(fieldsChanged);
  };

  saveChanges() {
    const { dispatch } = this.props;
    const { companyName, previewImgURL, file } = this.state;

    const user = {
      companyName,
      defaultCurrency: this.state.defaultCurrency,
    };

    if (!previewImgURL) {
      user.companyImageURL = '';
    }

    dispatch(
      userActions.updateProfile(user, file, () => {
        this.props.formChanged(false);
      }),
    );
  }

  renderDeleteAccountModal() {
    const { dispatch, isUserDeletingAccount } = this.props;
    const visible = this.props.deleteAccountError.length > 0;
    return (
      <Modal
        centered
        open={this.state.deleteModalOpen}
        size="mini"
        closeOnDimmerClick={!isUserDeletingAccount}
        closeIcon={!isUserDeletingAccount}
        onClose={() => {
          dispatch(userActions.resetDeleteAccountError());
          this.setState({
            deleteModalOpen: false,
            password: '',
          });
        }}
      >
        <div className="account-info-common-modal-title">
          {Strings.ACCOUNT_INFORMATION.deleteAccountPromptTitle}
        </div>
        <div className="account-info-common-section-container">
          <p className="common-modal-body">
            {' '}
            <b>{Strings.ACCOUNT_INFORMATION.deleteAccountPromptBody1}</b>
          </p>
          <p className="common-modal-body">
            {Strings.ACCOUNT_INFORMATION.deleteAccountPromptBody2}
          </p>
        </div>
        <div className="account-info-input-section">
          <Transition visible={visible} animation="fade" duration={500}>
            <p id="modal-error-text" className="delete-account-error">
              {this.props.deleteAccountError}
            </p>
          </Transition>
          <Input
            id="delete-account-password-input"
            placeholder={Strings.LOGIN.passwordHint}
            name="password"
            value={this.state.password}
            disabled={isUserDeletingAccount}
            type="password"
            onChange={(e, { value }) => this.setState({ password: value })}
          />
        </div>
        <div className="account-info-delete-modal-button-container">
          <Button
            className="common-grey-button"
            onClick={() => {
              this.setState({ deleteModalOpen: false });
            }}
          >
            {Strings.BILLING.cancel}
          </Button>
          <div style={{ width: 30 }} />
          <Button
            className="common-green-button"
            onClick={this.doDeleteAccount}
            disabled={!this.state.password}
            loading={isUserDeletingAccount}
          >
            {Strings.BILLING.continue}
          </Button>
        </div>
      </Modal>
    );
  }

  render() {
    const { previewImgURL } = this.state;
    const { companyName, subscription } = this.props;

    const uploadImage = previewImgURL ? (
      <Image id="upload-image" className="upload-img" src={previewImgURL} />
    ) : (
      <div id="upload-image" className="upload-img" />
    );
    const uploadImageText = previewImgURL ? null : (
      <p id="upload-image-text">{Strings.ACCOUNT_INFORMATION.addCompanyLogo}</p>
    );
    const uploadImagePlus = previewImgURL ? (
      <Image className="upload-img-plus" src="/logo-minus.png" />
    ) : (
      <Image className="upload-img-plus" src="/logo-plus.png" />
    );
    const planInfo = getPlanInfo(subscription);
    const UpgradeText = planInfo.canUpgrade ? (
      <p
        id="upgrade-text"
        onClick={() => {
          history.replace('/settings/billing#premium');
        }}
      >
        {Strings.ACCOUNT_INFORMATION.upgrade}
      </p>
    ) : (
      ''
    );
    return (
      <div className="settings-content">
        {this.renderDeleteAccountModal()}
        <div className="settings-multi-card-container account-info-container">
          <div className="settings-multi-card settings-company-info">
            <div
              className="upload-img-container"
              onClick={() => {
                if (previewImgURL) {
                  this.setState(
                    { previewImgURL: '', file: null },
                    this.checkFormChanged,
                  );
                } else {
                  window.document.getElementById('upload-image-input').click();
                }
              }}
            >
              {uploadImage}
              {uploadImagePlus}
              {uploadImageText}
              <input
                type="file"
                id="upload-image-input"
                accept="image/x-png,image/gif,image/jpeg"
                onChange={this.onFileChange}
              />
            </div>
            <div className="settings-company-info-name">
              <p id="company-name-title">Company name</p>
              <Input
                id="company-name-input"
                placeholder={companyName}
                defaultValue={companyName}
                name="companyName"
                onChange={this.handleCompanyNameChange}
              />
              <p id="upload-image">{Strings.ACCOUNT_INFORMATION.uploadImage}</p>
            </div>
          </div>

          <div className="settings-multi-card settings-account-info">
            <p id="info-text">{Strings.ACCOUNT_INFORMATION.emailAndUsername}</p>
            <p id="account-info-bold">{this.props.email}</p>
            <br />
            <p id="info-text">{Strings.ACCOUNT_INFORMATION.currentPlan}</p>
            <p id="account-info-bold">{planInfo.planText}</p> {UpgradeText}
          </div>
        </div>
        <p id="settings-security-title" className="settings-card-title">
          {Strings.ACCOUNT_INFORMATION.securitySettings}
        </p>
        <div className="account-info-system-settings-container settings-card">
          <div className="default-currency-container">
            <p id="settings-default-currency-title">
              {Strings.ACCOUNT_INFORMATION.defaultCurrency}
            </p>
            <Dropdown
              text={getCurrencyText(this.state.defaultCurrency)}
              basic
              className="settings-drop-down"
              fluid
              icon={<div className="settings-drop-down-icon" />}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  value={Strings.CURRENCIES.dollarCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.dollar}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.euroCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.euro}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.yenCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.yen}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.poundCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.pound}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.rubleCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.ruble}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.rupeeCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.rupee}
                </Dropdown.Item>
                <Dropdown.Item
                  value={Strings.CURRENCIES.rialCode}
                  onClick={this.changeCurrency}
                  className="settings-drop-down-item"
                >
                  {Strings.CURRENCIES.rial}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <button
          id="delete-account-button"
          className="common-light-button"
          onClick={this.onPressDeleteAccount}
        >
          {Strings.ACCOUNT_INFORMATION.deleteAccount}
        </button>
        <Image className="app-footer-logo" src="/circles-grey.png" />
      </div>
    );
  }
}

AccountInformation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isUserDeletingAccount: PropTypes.bool,
  companyName: PropTypes.string,
  companyImageURL: PropTypes.string,
  defaultCurrency: PropTypes.string,
  email: PropTypes.string,
  deleteAccountError: PropTypes.string,
  formChanged: PropTypes.func.isRequired,
  subscription: PropTypes.shape({
    status: PropTypes.string,
    cancelAtPeriodEnd: PropTypes.bool,
  }).isRequired,
};

AccountInformation.defaultProps = {
  isUserDeletingAccount: false,
  companyName: '',
  companyImageURL: '',
  defaultCurrency: Constant.DEFAULT_CURRENCY_CODE,
  email: '',
  deleteAccountError: '',
};

const mapStateToProps = state => ({
  isUserDeletingAccount: state.uiState.isUserDeletingAccount,
  companyName: state.user.companyName,
  companyImageURL: state.user.companyImageURL,
  defaultCurrency: state.user.defaultCurrency,
  email: state.user.email,
  deleteAccountError: state.uiState.deleteAccountError,
  subscription: state.premiumSubscription.subscription,
});

export default connect(
  mapStateToProps,
  null,
  null,
  { withRef: true },
)(AccountInformation);



// WEBPACK FOOTER //
// ./src/components/settings/AccountInformation.js